import React from "react"
import { ApolloProvider } from "@apollo/client"
import { getApolloClient } from "./ApolloClient"

export const WrapApolloProvider: React.FC = ({ children }) => {
  return <ApolloProvider client={getApolloClient()}>{children}</ApolloProvider>
}
